import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';
import useStaticWishlistData from './useStaticWishlistData';

const useFavoritesStaticProductData = () => {
  const { data } = useSuspenseQuery(GET_FAVORITED_PRODUCT_IDS);
  const productIds = data?.productIds ?? [];

  return useStaticWishlistData({productIds});
};

export default useFavoritesStaticProductData;
